import React from 'react';
import { withTranslation } from 'react-i18next';
// material ui
import {  Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
// components
import { PhotoGallery, VideoGallery } from './index';

const styles = theme => ({
    mainDiv:{
        width:'calc(100% - 20px)',
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
    },

    header:{
        fontSize:'20px',
        color:'#000',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },

    divider:{
        height:'2px',
        width:'100%',
        marginTop:'10px'
    }
})
// Gallery section
function Gallery(props) {
    const { t, i18n,classes, openDialog, photos, videos, fontDarkColor, label } = props;
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv}>
            <span className={classes.header} style={{fontFamily}}>{label ? label : t('companyPage.gallery')}</span>
            <PhotoGallery photos={photos} fontDarkColor={fontDarkColor}/>
            <Divider className={classes.divider}/>
            <VideoGallery openDialog={openDialog} videos={videos} fontDarkColor={fontDarkColor}/>
        </div>
    )
}

export default withStyles(styles)(withTranslation('common')(Gallery));